export default __webpack_public_path__ + "static/media/CLAIM.844dbc5d.svg";